import { ComputerOutlined, LocationOnOutlined } from '@mui/icons-material';
import { Box, Tooltip, Typography } from '@mui/material';

export const VeranstaltungOrt = ({ online, orte }: { online: boolean; orte: string[] }) => {
  const icon = online ? (
    <ComputerOutlined fontSize="small" sx={{ color: (theme) => theme.palette.text.tertiary }} />
  ) : (
    <LocationOnOutlined fontSize="small" sx={{ color: (theme) => theme.palette.text.tertiary }} />
  );
  const text = orte.join(', ');

  return (
    <Box display="flex" alignItems="center" gap={0.5} overflow="hidden">
      {icon}
      <Tooltip title={text.length === 0 ? 'Keine Location gebucht' : text} arrow disableInteractive>
        <Typography variant="labelSmLight" color="textTertiary" noWrap>
          {text.length === 0 ? '-' : text}
        </Typography>
      </Tooltip>
    </Box>
  );
};
